import {
  Directive,
  ContentChildren,
  QueryList,
  AfterContentInit,
  effect,
  inject,
  ViewContainerRef,
  ComponentRef,
  DestroyRef,
  Injector,
  runInInjectionContext
} from '@angular/core';

import {Field, FormField} from '@angular/forms/signals';
import {ErrorMessageComponent} from './error-component/error-component';

@Directive({
  selector: 'form[appAutoValidate]',
  standalone: true
})
export class ZodAutoValidateDirective implements AfterContentInit {

  @ContentChildren(FormField as any, {descendants: true})
  controls!: QueryList<FormField<any>>;

  private vcr = inject(ViewContainerRef);
  private destroyRef = inject(DestroyRef);
  private injector = inject(Injector);

  ngAfterContentInit() {
    this.controls.forEach(control => this.watchControl(control));

    // Support dynamically added/removed controls
    this.controls.changes.subscribe(() => {
      this.controls.forEach(control => this.watchControl(control));
    });
  }

  private watchControl(control: FormField<any>) {
    let errorComponent: ComponentRef<ErrorMessageComponent> | null = null;

    runInInjectionContext(this.injector, () => {
      const stop = effect(() => {
        const errors = control.state().errors();
        const touched = control.state().touched();
        const invalid = control.state().invalid();

        if (invalid && touched && errors) {
          const firstError: any = Object.values(errors)[0];
          const message = firstError?.message ?? 'Invalid value';

          if (!errorComponent) {
            errorComponent = this.vcr.createComponent(ErrorMessageComponent);

            const host =
              (control as any).nativeEl ||
              (control as any).element;

            if (host) {
              host.insertAdjacentElement(
                'afterend',
                errorComponent.location.nativeElement
              );
            }
          }

          errorComponent.instance.text.set(message);
        } else {
          errorComponent?.destroy();
          errorComponent = null;
        }
      });

      // Clean up the effect when directive is destroyed
    });
  }
}
